import React, { VFC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@dxb-web-ui-framework/design-system';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import {
  useWizardStepData,
  useWizardGoToPreviousStep,
  useWizardGoToNextStep,
} from '../../../../content-composer/src/contexts/ClientSideWizard/hooks';
import { ContentWrapper } from '../../../../content-composer/src/components/Generic/ContentWrapper';
import { InAPP2FAStep } from '../../../../content-composer/src/components/ClientSideWizard/Steps/InApp2FAStep';

const TransferOTP: VFC = () => {
  const { t } = useTranslation();
  const transferConfirmData = useWizardStepData('transferConfirm') as GenericObject;
  const goToPreviousStep = useWizardGoToPreviousStep();
  const goToNextStep = useWizardGoToNextStep();
  const { authenticationMethod } = transferConfirmData.values;
  useEffect(() => {
    if (authenticationMethod === null) {
      setTimeout(() => goToNextStep({}), 1);
    }
  }, [authenticationMethod]);
  return (
    <ContentWrapper
      hasDivider={false}
      boxProps={{
        paddingLeft: 3,
        paddingRight: 3,
        paddingTop: 4,
        boxShadow: '0 3px 20px #00000033',
        height: '100%',
      }}>
      <Grid container>
        <Grid item xs={12} md={5}>
          {authenticationMethod !== null && (
            <InAPP2FAStep
              stepId='transferConfirm'
              authenticationMethod={authenticationMethod}
              isLeftPositioned={authenticationMethod === 'OTP' ? true : false}
              title={t('FundsTransfersPage.TransferOtp.title')}
              shouldEnableOtpTitle={false}
              shouldForceMobileOtpView={true}
              resetFlow={goToPreviousStep}
            />
          )}
        </Grid>
      </Grid>
    </ContentWrapper>
  );
};

export { TransferOTP };
